module.exports = __webpack_public_path__ + "static/media/mobile-background-5.122dd653.jpg";